import React from 'react'
import { TextInput, required, maxLength } from 'react-admin'
import LanguagesNav from '../../../../components/languagesNav'
import { Grid } from '@material-ui/core'

class ChatbotQuestionsForm extends React.Component {
  render() {
    const { record } = this.props

    return (
      <LanguagesNav {...this.props}>
        <Grid container>
          <Grid item xs={12}>
            <TextInput source="question" label="Question" fullWidth disabled={record.country === '_DEFAULT'} validate={[required(), maxLength(255)]} />
          </Grid>
        </Grid>
      </LanguagesNav>
    )
  }
}

export default ChatbotQuestionsForm
